<template>
  <div id="app" :style="flag ? 'overflow-x:hidden;' : ''">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
export default {
  name: "app",
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      flag: "",
    };
  },
  created() {
    this.addLog();
  },
  mounted() {
    this.isMobile();
    this.$store.commit("getUseifo");
    if (this.$store.state.userinfo) {
      console.log(this.$store.state.userinfo);
      sessionStorage.setItem(
        "userinfo",
        JSON.stringify(this.$store.state.userinfo)
      );
    }
    // window.addEventListener("unload", this.saveState);
  },
  methods: {
    addLog() {
      this.$axios.post("log/visitnums_add");
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag) this.flag = true;
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>
<style lang="less">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

ul {
  list-style: none;
}

a {
  text-decoration: none;
  color: #000;
}

#app>div {
  position: relative;
  min-height: 100vh;
  padding-bottom: 1.6rem;
}

.el-carousel {
  .el-carousel__indicator {
    >button {
      width: 0.1rem;
      height: 0.1rem;
      border-radius: 50%;
    }
  }
}

.el-message {
  font-size: 0.16rem;
  z-index: 150000;
}

.ql-editor {
  p {
    max-width: 100%;
    margin: 0 auto;

    img {
      max-width: 100%;
      display: block;
      margin: 0 auto;
    }
  }
}

.el-input__icon {
  line-height: 1 !important;
}

.el-date-editor .el-range-separator {
  width: 8% !important;
  line-height: 0.25rem !important;
}
</style>